import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Begin
const MailEditor = () => import('../views/MailEditor.vue')
const SecuredView = () => import('../views/SecuredView.vue')
const SigninView = () => import('../views/SigninView.vue')
const SignupView = () => import('../views/SignupView.vue')
// const createGridView = id => () => import('../views/createGridView').then(m => m.default(id))
const ProfileView = () => import('../views/ProfileView.vue')
const ProfileUpdate = () => import('../views/ProfileUpdate.vue')

// route-level code splitting
// const createListView = id => () => import('../views/CreateListView').then(m => m.default(id))
const ItemView = () => import('../views/ItemView.vue')
const UserView = () => import('../views/UserView.vue')
const HomeView = () => import('../views/HomeView.vue')

const TableView = () => import('../views/TableView.vue')
const FastRunnerTableView = () => import('../views/FastRunnerTableView.vue')

export function createRouter () {
	return new Router({
		mode: 'history',
		fallback: false,
		scrollBehavior: () => ({ y: 0 }),
		routes: [
			// { path: '/top/:page(\\d+)?', component: createListView('top') },
			// { path: '/new/:page(\\d+)?', component: createListView('new') },
			// { path: '/show/:page(\\d+)?', component: createListView('show') },
			// { path: '/ask/:page(\\d+)?', component: createListView('ask') },
			// { path: '/job/:page(\\d+)?', component: createListView('job') },

			{ path: '/item/:id(\\d+)', component: ItemView },
			{ path: '/user/:id', component: UserView },

			{ path: '/profile', component: ProfileView },
			{ path: '/profile/:dataId', component: ProfileUpdate },
			// { path: '/event_participant/:page(\\d+)?', component: createGridView('event_participant') },
			{ path: '/signin/:action*', component: SigninView },
			{ path: '/signup/:action*', component: SignupView },
			// { path: '/admin', component: SecuredView },
			{ path: '/maileditor', component: MailEditor },
			{ path: '/', component: HomeView },
			{ path: '*', component: HomeView },

			{ path: '/list/:page(\\d+)?', component: TableView },
			{ path: '/list_fastrunner/:page(\\d+)?', component: FastRunnerTableView },

			// { path: '/', redirect: '/profile' },
		]
	})
}



// WEBPACK FOOTER //
// src/router/index.js